// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation_navigation__hR1U8 {
  flex-grow: 1;
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  column-gap: 5rem;
}

.Navigation_navigation__categories-list__Gpp8i {
  display: grid;
  grid-template-columns: repeat(2, minmax(auto, 1fr));
  gap: 1.5rem 5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardFooter/Sitemap/Navigation/Navigation.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,gBAAgB;AAClB","sourcesContent":[".navigation {\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: auto 1fr 1fr;\n  column-gap: 5rem;\n}\n\n.navigation__categories-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(auto, 1fr));\n  gap: 1.5rem 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `Navigation_navigation__hR1U8`,
	"navigation__categories-list": `Navigation_navigation__categories-list__Gpp8i`
};
export default ___CSS_LOADER_EXPORT___;
